import { Search } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import React, { useEffect, useState } from 'react';
import { Box, InputV2, TextV2 } from '@withjoy/joykit';

import { useTranslation } from '@shared/core';
import { useDebouncedValue } from '@shared/hooks/useDebouncedValue';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

type CarNameSearchProps = Readonly<{
  value: string;
  onChange: (value: string) => void;
}>;

export const CarNameSearch = ({ value, onChange }: CarNameSearchProps) => {
  const { tq } = useTranslation('carRentalConsole');
  const [searchInput, setSearchInput] = useState(value);

  const { setValue: setDebouncedSearch, value: debouncedSearch } = useDebouncedValue<string>(500);
  const onChangeEvent = useEventCallback(onChange);

  useEffect(() => {
    setSearchInput(value);
  }, [value]);

  useEffect(() => {
    setDebouncedSearch(searchInput);
    return () => setDebouncedSearch.cancel();
  }, [searchInput, setDebouncedSearch]);

  useEffect(() => {
    if (debouncedSearch !== undefined) {
      onChangeEvent(debouncedSearch);
    }
  }, [debouncedSearch, onChangeEvent]);

  return (
    <Box>
      <TextV2
        typographyVariant="hed2"
        marginBottom={pxToRem(10)}
      >
        {tq`Search by car`}
      </TextV2>
      <InputV2
        value={searchInput}
        startElement={<Search />}
        aria-label={tq`Search by car`}
        placeholder={tq`e.g., Toyota Corolla`}
        onChange={event => setSearchInput(event.target.value)}
      />
    </Box>
  );
};
